import { render, staticRenderFns } from "./ImportantPrjCS.vue?vue&type=template&id=9d650cee&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./ImportantPrjCS.vue?vue&type=script&lang=js&"
export * from "./ImportantPrjCS.vue?vue&type=script&lang=js&"
import style0 from "./ImportantPrjCS.vue?vue&type=style&index=0&id=9d650cee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d650cee",
  null
  
)

export default component.exports